export default __webpack_public_path__ + "images/hotel_icon.1f2774c.png";